// TechnologyConetnt

import React, { FC, useCallback } from 'react';
import styles from './TechnologyConetnt.module.scss';
import VideoPlayer from '../../components/VideoPlayer';
import Comma from '../../components/Comma';
import NewsGroup from '../../components/NewsGroup';
import AIToolList from './AIToolList';
import AIProductIntroList from './AIProductIntroList';
import AIApplicationList from './AIApplicationList';
import TechProductCard from './TechProductCard';
import ResearchCooperation from './ResearchCooperation';
import TechInnovation from './TechInnovation';
import { Props } from './type';

export interface DataType {
  [key: string]: string;
}

const TechnologyConetnt: FC<Props> = (props) => {
  const {
    manMachineData,
    productCardDataArr,
    productIntroDataArr,
    aiApplicationData,
    toolData,
    researchCooperationData,
    scientificCooperationData,
    newsGroupData,
  } = props;

  // todo pm要求一直播放，不允许暂停，现用hack处理办法，如果暂停就业务主动在触发继续播放
  const onPause = useCallback((player: any) => {
    player?.play();
  }, []);

  return (
    <section className={styles['technology-conetnt-box']}>
      {/* 新闻模块 */}
      <NewsGroup
        className={styles['technology-news-group']}
        lanType={newsGroupData.lanType}
        newsPositionNo="msgcenter_4"
        linkUrl="/news?category=technological-innovations"
        titleText={newsGroupData.newsTitleText}
        moreText={newsGroupData.newsMoreText}
        newsLimit={3}
      />

      {/* AI 产品介绍列表模块 */}
      <AIProductIntroList productIntroDataArr={productIntroDataArr} />

      {/* AI 应用生活列表模块 */}
      <AIApplicationList {...aiApplicationData} />

      {/* AI工具列表模块 */}
      <AIToolList {...toolData} />

      {/* 技术产品卡片示例 - 无人机 */}
      <div className={styles['technology-conetnt-uav-car']}>
        {productCardDataArr.map((data, index) => (
          <TechProductCard key={index} {...data} />
        ))}
      </div>

      {/* 人机城相关模块 */}
      <div className="px-[30px] pt-[30px] lg:pt-[80px]">
        <div className={styles['content-item-wrap']}>
          {/* 人机城标题 */}
          <div className={styles['content-item-title']}>
            <div className={styles['content-item-title-item']}>{manMachineData.titleMain}</div>
            {manMachineData.titleVice && (
              <span className={styles['comma-box']}>
                <Comma />
              </span>
            )}

            <div className={styles['content-item-title-item']}>{manMachineData.titleVice}</div>
          </div>
          {/* 人机城介绍信息 */}
          <div className={styles['content-item-intro']}>
            <p>{manMachineData.intro1}</p>
            <p>{manMachineData.intro2}</p>
          </div>

          {/* 人机城相关视频 */}
          <div className={styles['video-box']}>
            <div className={styles['video-wrap']}>
              <VideoPlayer
                onPause={onPause}
                source={manMachineData.relevantVideo1}
                poster={manMachineData.relevantPoster1}
                autoplay
                hideControl
              />
            </div>
            <div className={styles['video-wrap']}>
              <VideoPlayer
                onPause={onPause}
                source={manMachineData.relevantVideo2}
                poster={manMachineData.relevantPoster2}
                autoplay
                hideControl
              />
            </div>
          </div>
        </div>
      </div>

      {/* 科研合作数据展示模块（专利统计 + 授权数量柱状图） */}
      {researchCooperationData && (
        <div className="px-[30px] pt-[30px] lg:pt-[80px]">
          <ResearchCooperation {...researchCooperationData} />
        </div>
      )}

      {/* 科技创新相关模块 */}
      {scientificCooperationData && (
        <div className="px-[30px] pt-[30px] lg:pt-[80px]">
          <TechInnovation {...scientificCooperationData} />
        </div>
      )}
    </section>
  );
};
TechnologyConetnt.defaultProps = {};

TechnologyConetnt.displayName = 'TechnologyConetnt';
export default TechnologyConetnt;
